import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../mensajes2";
import { Dimmer } from "../spinner";
import { validaSoloNumero } from "../../util/varios";
import "react-tabs/style/react-tabs.css";
import axios from "axios";
import CatalogoContable from "../../catalogos/catalogoContable";

import { DangerButton, SuccessButton } from "../../ui/buttons/Button";
import { Input, SearchInput } from "../../ui/inputs/Input";

export const ModalTiOrPag = (props) => {
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  let op = require("../../../src/modulos/datos");

  const btnCancela = useRef();
  const btnAcepta = useRef();

  const txtId1 = useRef();
  const txtId2 = useRef();
  const txtId3 = useRef();
  const txtId4 = useRef();
  const txtId5 = useRef();

  const txtDescrip1 = useRef();
  const txtDescrip2 = useRef();
  const txtDescrip3 = useRef();
  const txtDescrip4 = useRef();
  const txtDescrip5 = useRef();

  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [visible, setVisible] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  let token = localStorage.getItem("jwtToken");

  const validarCampos = (e) => {
    e.preventDefault();
    var sigue = true;
    if (txtId1.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe ingresar la cuenta contable de Orden de Compra",
        icono: "informacion",
      });
      sigue = false;
      txtId1.current.focus();
    } else if (txtId2.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe ingresar la cuenta contable de Pago de Obras",
        icono: "informacion",
      });
      sigue = false;
      txtId2.current.focus();
    } else if (txtId3.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe ingresar la cuenta contable de Orden de Servicio",
        icono: "informacion",
      });
      sigue = false;
      txtId3.current.focus();
    } else if (txtId4.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe ingresar la cuenta contable de Pago Directo",
        icono: "informacion",
      });
      sigue = false;
      txtId4.current.focus();
    } else if (txtId5.current.value.trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Información",
        texto: "Debe ingresar la cuenta contable de Pago Nomina",
        icono: "informacion",
      });
      sigue = false;
      txtId5.current.focus();
    }
    if (sigue === true) {
      selectRegValor();
    }
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.setShow(false);
  };

  const seleccionarRegistro = () => {
    let endpoint = `${op.conexion}/api/contabilidadfis/selecttipordpago?idefiscal=${idefiscal}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          for (let i = 0; i < response.data.length; i++) {
            if (parseInt(response.data[i].idtipomovimiento) === 5) {
              setOperacion(1);
              seleccionarCuenta(1, response.data[i].idcuentacontable);
            } else if (parseInt(response.data[i].idtipomovimiento) === 7) {
              setOperacion(2);
              seleccionarCuenta(2, response.data[i].idcuentacontable);
            } else if (parseInt(response.data[i].idtipomovimiento) === 11) {
              setOperacion(3);
              seleccionarCuenta(3, response.data[i].idcuentacontable);
            } else if (parseInt(response.data[i].idtipomovimiento) === 12) {
              setOperacion(4);
              seleccionarCuenta(4, response.data[i].idcuentacontable);
            } else if (parseInt(response.data[i].idtipomovimiento) === 13) {
              setOperacion(5);
              seleccionarCuenta(5, response.data[i].idcuentacontable);
            }
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const selectRegValor = () => {
    let endpoint = `${op.conexion}/api/contabilidadfis/vinculartipoorden`;
    let body;
    setActivate(true);
    body = {
      idefiscal: idefiscal,
      id1: txtId1.current.value,
      id2: txtId2.current.value,
      id3: txtId3.current.value,
      id4: txtId4.current.value,
      id5: txtId5.current.value,
    };
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Vinculacion Exitosa.",
            icono: "exito",
          });
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const blanquearCampos = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setActivate(false);
    setOperacion();
    setDeshabilitado();
    setVisible();
  };

  const salir = () => {
    props.setShow(false);
    blanquearCampos();
  };

  const seleccionarCuenta = (operacion, id) => {
    setMostrar(false);

    let endpoint = `${op.conexion}/api/contabilidadfis/selectctaconta?id=${id}&idefiscal=${idefiscal}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            console.log(response.data);
            if (operacion === 1) {
              txtId1.current.value = response.data.idcuentacontable;
              txtDescrip1.current.value = response.data.descripcion;
            } else if (operacion === 2) {
              txtId2.current.value = response.data.idcuentacontable;
              txtDescrip2.current.value = response.data.descripcion;
            } else if (operacion === 3) {
              txtId3.current.value = response.data.idcuentacontable;
              txtDescrip3.current.value = response.data.descripcion;
            } else if (operacion === 4) {
              txtId4.current.value = response.data.idcuentacontable;
              txtDescrip4.current.value = response.data.descripcion;
            } else if (operacion === 5) {
              txtId5.current.value = response.data.idcuentacontable;
              txtDescrip5.current.value = response.data.descripcion;
            }
            setActivate(false);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe una Cuenta Contable con este Codigo.",
              icono: "informacion",
            });
            setActivate(false);
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarPlancuenta = (num) => (event) => {
    event.preventDefault();
    setOperacion(num);
    validaSoloNumero(event);
    if (num === 1) {
      txtDescrip1.current.value = "";
    } else if (num === 2) {
      txtDescrip2.current.value = "";
    } else if (num === 3) {
      txtDescrip3.current.value = "";
    } else if (num === 4) {
      txtDescrip4.current.value = "";
    } else if (num === 5) {
      txtDescrip5.current.value = "";
    }
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarCuenta(num, event.target.value);
      } else {
      }
    }
  };

  const handleAceptaCuenta = (id) => {
    seleccionarCuenta(operacion, id);
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setDeshabilitado(props.deshabilitado);
        setOperacion(props.operacion);
        seleccionarRegistro();
        setVisible(false);
      }}
    >
      <Modal.Header className="azulGradiant">
        <h3 className="fw-bold m-0">Vincular Tipo de Ordenes de Pago</h3>
        <a
          type="button"
          ref={btnCancela}
          onClick={salir}
          className="text-light fw-bold fs-6"
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body>
        <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
          <legend className="float-none w-auto">
            Relacion Cuenta Contable
          </legend>
          <div className="col-12 m-0 mb-2 p-0 d-flex">
            <SearchInput label='Orden de Compra:'
              name="idcuentabancaria"
              onKeyUp={validarPlancuenta(1)}
              onBlur={validarPlancuenta(1)}
              onClickButton={() => { setMostrar(true), setOperacion(1) }}
              ref={txtId1}
            />
            <Input
              id="codigocuenta"
              name="codigocuenta"
              disabled
              ref={txtDescrip1}
            />
          </div>
          <div className="col-12 m-0 mb-2 p-0 d-flex">
            <SearchInput label='Pago de Obras:'
              onKeyUp={validarPlancuenta(2)}
              onBlur={validarPlancuenta(2)}
              ref={txtId2}
              onClickButton={() => { setMostrar(true), setOperacion(2) }}
            />
            <Input
              id="codigocuenta"
              name="codigocuenta"
              disabled
              ref={txtDescrip2}
            />
          </div>
          <div className="col-12 m-0 mb-2 p-0 d-flex">
            <SearchInput label='Orden de Servicio:'
              name="idcuentabancaria"
              onKeyUp={validarPlancuenta(3)}
              onBlur={validarPlancuenta(3)}
              onClickButton={() => { setMostrar(true), setOperacion(3) }}
              ref={txtId3}
            />
            <Input
              id="codigocuenta"
              name="codigocuenta"
              disabled
              ref={txtDescrip3}
            />
          </div>
          <div className="col-12 m-0 mb-2 p-0 d-flex">
            <SearchInput label='Pago Directo:'
              name="idcuentabancaria"
              onKeyUp={validarPlancuenta(4)}
              onBlur={validarPlancuenta(4)}
              onClickButton={() => { setMostrar(true), setOperacion(4) }}
              ref={txtId4}
            />
            <Input
              id="codigocuenta"
              name="codigocuenta"
              disabled
              ref={txtDescrip4}
            />
          </div>
          <div className="col-12 m-0 p-0 d-flex">
            <SearchInput label='Pago de Nomina:'
              name="idcuentabancaria"
              onKeyUp={validarPlancuenta(5)}
              onBlur={validarPlancuenta(5)}
              onClickButton={() => { setMostrar(true), setOperacion(5) }}
              ref={txtId5}
            />
            <Input
              id="codigocuenta"
              name="codigocuenta"
              disabled
              ref={txtDescrip5}
            />
          </div>
        </fieldset>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          disabled={operacion === 4 ? true : false}
          onClick={validarCampos}
          ref={btnAcepta}
        >
          Aceptar
        </SuccessButton>
        <DangerButton
          ref={btnCancela}
          onClick={salir}
        >
          Salir
        </DangerButton>
      </Modal.Footer>
      <CatalogoContable
        show={mostrar}
        onHideCancela={() => {
          setMostrar(false);
        }}
        onHideAcepta={handleAceptaCuenta}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({
              mostrar: false,
              titulo: "",
              texto: "",
              icono: "",
            });
        }}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </Modal>
  );
};
